module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box american-credit-partner"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("Loan Calculator & Payment Estimator")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#ffffff",
      "color": "rgb(84, 86, 255)",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "1px solid rgb(84, 86, 255)",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        return this.window.open('https://youtu.be/JH96Q66Y4Hc', '_blank')
      }
    }
  }, [_vm._v("Watch Demo")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Team Customer Voice Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("I need to spend my time meeting customers’ expectations, not on lengthy loan applications.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(5)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Get the credit you deserve from a lender you can trust. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "american-credit-roi-head-img",
    attrs: {
      "src": require("../assets/imgs/American_Credit_Loancaculator_ROI.png"),
      "alt": "American Credit Loancaculator ROI"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#053a7a"
    }
  }, [_c('div', {
    staticClass: "container bluebg text-center"
  }, [_c('br'), _vm._v(" "), _c('h2', {
    staticClass: "display-5 text-whitee text-center font-weight-bolder"
  }, [_vm._v("Estimate your asset-based loan monthly payment")]), _vm._v(" "), _c('div', {
    staticClass: "contexbox1 text-center"
  }, [_c('br'), _vm._v(" "), _c('h5', {
    staticClass: "text-whitee font-weight-bold"
  }, [_vm._v("See a quick snapshot of your asset-based loan monthly installment payments.")]), _vm._v(" "), _c('h6', {
    staticClass: "text-whitee"
  }, [_vm._v("It’s always important to know what to expect before borrowing money. So, use our asset-based loan calculator to get an estimate of your monthly installment in principal repayment and interest payment on an American Credit"), _c('sup', [_vm._v("®")]), _vm._v(" asset-based loan. You can adjust the term and initial principal amount to see the impact they may have on monthly payment.")]), _vm._v(" "), _c('h2', {
    staticClass: "display-5 text-whitee text-center font-weight-bolder",
    attrs: {
      "id": "loanCalculator",
      "name": "loanCalculator"
    }
  }, [_vm._v("Calculate your sample asset-based loan")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('iframe', {
    staticClass: "bg-light",
    attrs: {
      "src": "/static/LoanCalculator/LoanCalculator.html",
      "width": "100%",
      "height": "988px"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "contexbox text-center"
  }, [_c('h6', [_vm._v("\n            To see exactly what your interest rate will be, please apply for your equipment financing or invoice financing loan now. Doing so is absolutely free, \n            will not affect your credit score and you are under no obligation to accept our offer of a loan or line of credit.\n          ")])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Team_Customer_Voice.png"),
      "alt": "American Credit Team Customer Voice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("Laurie Townsend")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("Account Receivable Manager, Lone Star Uniform Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74df4bcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loanCalculator.vue
// module id = 1994
// module chunks = 5